import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'semantic-ui-react';
import { DyzioModalHeader } from 'dyzio-shared-components/lib/components/dyzio-modal';

import EventFeed from '../../containers/event-feed';

const ScanHistoryModal = ({
  discussionId,
  onClose,
}) => (
  <Modal open onClose={onClose}>
    <DyzioModalHeader headerText="Scan history" onClose={onClose} />
    <Modal.Content>
      <EventFeed
        title="Feed"
        description="collaboration events"
        feedType="COLLABORATION"
        discussionId={discussionId}
        viewMode="TABLE"
        isCompact
      />
    </Modal.Content>
  </Modal>
);

ScanHistoryModal.propTypes = {
  discussionId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ScanHistoryModal;



/** WEBPACK FOOTER **
 ** ./src/components/scan-history-modal/index.js
 **/